import React from 'react';
import ModernHeroSection from '../Components/ModernHeroSection.jsx';
import WhyChooseUs from '../Components/WhyChooseUs.jsx';
import OurTechnologies from '../Components/OurTechnologies.jsx';
import ModernFeatures from '../Components/ModernFeatures.jsx';
import WorkFlow from '../Components/WorkFlow.jsx';
import TrustedClients from '../Components/TrustedClients.jsx';
import CTASection from '../Components/CTASection.jsx';

const HomePage = () => {
  return (
    <main role="main">
      <ModernHeroSection />
      <WhyChooseUs />
      <OurTechnologies />
      <ModernFeatures />
      <WorkFlow />
      <TrustedClients />
      <CTASection />
    </main>
  );
};

export default HomePage;
